const baseOptions = [
  {
    name: "title",
    type: "Section",
    fields: [
      {
        name: "title",
        type: "String",
      },
      {
        name: "titlePosition",
        options: ['in', 'out', 'none'],
        type: "list",
      },
    ],
  },
  {
    name: "titleTextStyle",
    type: "Object",
    fields: [
      {
        name: "color",
        type: "String",
      },
      {
        name: "fontSize",
        type: "Int",
      },
      {
        name: "bold",
        type: "Boolean",
      },
      {
        name: "italic",
        type: "Boolean",
      },
    ],
  },
  {
    name: "Color",
    type: "Section",
    fields: [
      {
        name: "backgroundColor",
        type: "String",
      },
      {
        name: "chartArea.backgroundColor",
        type: "String",
      },
      {
        name: "colors",
        type: "Array",
      },
    ],
  },
  {
    name: "Axis Titles",
    type: "Section",
    fields: [
      {
        name: "axisTitlesPosition",
        type: "list",
        options: ['in', 'out', 'none'],
      },
      {
        name: "vAxis.title",
        type: "String",
      },
      {
        name: "hAxis.title",
        type: "String",
      },
    ],
  },
  {
    name: "General",
    type: "Section",
    fields: [
      {
        name: "orientation",
        type: "list",
        options: ['vertical', 'horizontal'],
      },
      {
        name: "focusTarget",
        type: "list",
        options: ['datum', 'category'],
      },
      {
        name: "isStacked",
        type: "Boolean",
      },
      {
        name: "theme",
        type: "list",
        options: ['maximized', 'none'],
      },
    ],
  },
  {
    name: "histogram",
    type: "Object",
    fields: [
      {
        name: "bucketSize",
        type: "number",
      },
      {
        name: "hideBucketItems",
        type: "Boolean",
      },
      {
        name: "lastBucketPercentile",
        type: "Int",
      },
      {
        name: "minValue",
        type: "Int",
      },
      {
        name: "maxValue",
        type: "Int",
      },
      {
        name: "numBucketsRule",
        type: "list",
        options: ["sqrt", "sturges", "rice"],
      },
    ],
  },
];

const options = [
  {
    name: "backgroundColor",
    type: "Object",
    fields: [
      {
        name: "stroke",
        type: "String",
      },
      {
        name: "strokeWidth",
        type: "Int",
      },
      {
        name: "fill",
        type: "String",
      },
    ],
  },
  {
    name: "chartArea",
    primitive: false,
    type: "Object",
    fields: [
      {
        name: "left",
        primitive: true,
        type: "String",
        default: "auto",
      },
      {
        name: "top",
        primitive: true,
        type: "String",
        default: "auto",
      },
      {
        name: "width",
        primitive: true,
        type: "String",
        default: "auto",
      },
      {
        name: "height",
        primitive: true,
        type: "String",
        default: "auto",
      },
    ],
  },
  {
    name: "legend",
    primitive: false,
    type: "Object",
    fields: [
      {
        name: "pageIndex",
        primitive: true,
        type: "Int",
        default: "0",
      },
      {
        name: "position",
        primitive: true,
        type: "list",
        options: ['bottom', 'left', 'in', 'none', 'right', 'top'],
      },
      {
        name: "alignment",
        primitive: true,
        type: "list",
        options: ['start', 'center', 'end'],
      },
    ],
  },
  {
    name: "Data",
    type: "Section",
    fields: [
      {
        name: "dataOpacity",
        type: "Int",
      },
      {
        name: "interpolateNulls",
        type: "Boolean",
      },
      {
        name: "isStacked",
        type: "list",
        options: ['percent', 'relative', 'absolute'],
      },
      {
        name: "reverseCategories",
        type: "Boolean",
      },
    ],
  },
  {
    name: "Font",
    type: "Section",
    fields: [
      {
        name: "fontSize",
        type: "Int",
      },
      {
        name: "fontName",
        type: "String",
      },
    ],
  },
  {
    name: "hAxis",
    type: "Section",
    fields: [
      {
        name: "baseline",
        type: "Int",
      },
      {
        name: "baselineColor",
        type: "String",
      },
      {
        name: "direction",
        type: "list",
        options: [1, -1],
      },
      {
        name: "format",
        type: "list",
        options: ['none', 'decimal', 'scientific', 'currency', 'percent', 'short', 'long'],
      },
      {
        name: "textPosition",
        type: "list",
        options: ['out', 'in', 'none'],
      },
      {
        name: "maxValue",
        type: "Int",
      },
      {
        name: "minValue",
        type: "Int",
      },
    ],
  },
  {
    name: "Tooltip",
    type: "Section",
    fields: [
      {
        name: "tooltip.trigger",
        type: "list",
        options: ['focus', 'none', 'selection'],
      },
    ],
  },
  {
    name: "vAxis",
    type: "Section",
    fields: [
      {
        name: "baseline",
        type: "Int",
      },
      {
        name: "baselineColor",
        type: "String",
      },
      {
        name: "direction",
        type: "list",
        options: [1, -1],
      },
      {
        name: "format",
        type: "list",
        options: ['none', 'decimal', 'scientific', 'currency', 'percent', 'short', 'long'],
      },
      {
        name: "textPosition",
        type: "list",
        options: ['out', 'in', 'none'],
      },
      {
        name: "maxValue",
        type: "Int",
      },
      {
        name: "minValue",
        type: "Int",
      },
    ],
  },
];

export default {
  baseOptions,
  options,
};
